<template>
    <b-modal id="modal-agenda" :hide-footer="true" :title="title" centered size="lg" :visible="false"
        :no-close-on-backdrop="true" :tabindex="0">
        <div class="row">
            <div class="col-lg-12" :class="'video-list'">
                <iframe width="100%" height="100%" :src="url_video" :title="title" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: ["item", "visible", "title", "url_video", "title_video"],
    data() {
        return {
            loading: false,
            videos: [
                { url: 'https://www.youtube.com/embed/BN3MNC1-S6w?si=vHl2Ny8nDMRnRrKr', title: 'Tutorial Agenda' }
            ]
        };
    },
    mounted() {
        this.url_video = this.videos[0].url;
        this.title_video = this.videos[0].title;
    },
    methods: {
    }
};
</script>
<style scoped>
.video-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
</style>